import { Group, Text, Image } from "@mantine/core";
import logo from "../../media/lmudrive-logo.png";
import applogo from "../../media/lmudrive-logo.png";

import classes from "./Logo.module.css";


interface LogoProps {
  logo?: string;
  name?: string;
}
export default function Logo({logo = applogo, name = "SimRacing SOLUTIONS"}: LogoProps): React.JSX.Element {
  return (
    <Group className={classes.logo}>
      <Text fs="italic" size="xl">
        {name}
      </Text>
    </Group>
  );
}
